"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Do I need a consultation before my first aesthetics treatment?",
  answer: "Yes, we require a comprehensive consultation prior to any aesthetic procedure. This allows our specialists to understand your unique goals, assess your suitability, and design a bespoke treatment plan tailored specifically to you."
}, {
  question: "What is your cancellation and rescheduling policy?",
  answer: "We kindly request a minimum of 48 hours' notice for any cancellations or rescheduling. This ensures we can offer the appointment to another client. Late cancellations may incur a fee as detailed in our booking terms."
}, {
  question: "How should I prepare for my massage appointment?",
  answer: "We recommend arriving 10-15 minutes early to unwind in our relaxation area. Please avoid heavy meals immediately before your treatment and inform your therapist of any specific areas of tension or medical conditions."
}, {
  question: "Are your beauty and aesthetic products cruelty-free?",
  answer: "Absolutely. Natalia's Beauty is committed to using only premium, ethically sourced products. The majority of our professional ranges are cruelty-free and vegan-friendly. Please ask your therapist for specific product details."
}, {
  question: "Do you offer bespoke packages combining different treatments?",
  answer: "Yes, we specialize in curating personalized sanctuary experiences. Whether you wish to combine a rejuvenating facial with a deep tissue massage or plan a pre-wedding aesthetics timeline, our team will craft the perfect package for you."
}];
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="faq" className="bg-background py-[160px] px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={`mx-auto max-w-3xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="mb-16 text-center">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-[0.1em] text-foreground">
            Frequently Asked{" "}
            <em className="italic font-light text-ring">Questions</em>
          </h2>
        </div>

        <div className="bg-card/40 backdrop-blur-md border border-border/50 rounded-[32px] p-6 md:p-10 lg:p-12 shadow-sm">
          <Accordion type="single" collapsible className="w-full [&_svg]:text-ring/80">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/40 py-2 first:pt-0 last:pb-0 last:border-0">
                <AccordionTrigger className="font-sans text-base md:text-lg text-foreground hover:text-ring transition-colors duration-300 hover:no-underline text-left leading-snug">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-muted-foreground text-sm md:text-base leading-relaxed pt-2 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}